import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Modal from 'bootstrap/js/dist/modal';
import '@oeii/js/main.js';
import '@oeii/js/newsletter-loader.js';

window.bootstrap = {Collapse, Dropdown, Modal};

if (document.querySelector('.tx-fehquiz')) {
    import('@oeii/js/quiz.js');
}
if (document.querySelector('.shariff')) {
    import('@oeii/js/shariff.js');
}
if (document.querySelector('form[data-suggest]')) {
    import('@oeii/js/solr.js');
}
